import React from 'react';

const StopsContext = React.createContext({
    stops: [],
    setStops: () => {}
});

export default StopsContext;